/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_Large_Json_Files_Faq_Q1Inputs */

const en_guide_large_json_files_faq_q1 = /** @type {(inputs: Guide_Large_Json_Files_Faq_Q1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What's the largest JSON file I can open in PureJSON?`)
};

const ko_guide_large_json_files_faq_q1 = /** @type {(inputs: Guide_Large_Json_Files_Faq_Q1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PureJSON에서 열 수 있는 가장 큰 JSON 파일은 얼마인가요?`)
};

const ja_guide_large_json_files_faq_q1 = /** @type {(inputs: Guide_Large_Json_Files_Faq_Q1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PureJSONで開ける最大のJSONファイルサイズは？`)
};

/**
* | output |
* | --- |
* | "What's the largest JSON file I can open in PureJSON?" |
*
* @param {Guide_Large_Json_Files_Faq_Q1Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_large_json_files_faq_q1 = /** @type {((inputs?: Guide_Large_Json_Files_Faq_Q1Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_Large_Json_Files_Faq_Q1Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_large_json_files_faq_q1(inputs)
	if (locale === "ko") return ko_guide_large_json_files_faq_q1(inputs)
	return ja_guide_large_json_files_faq_q1(inputs)
});